function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from "react";
import { Select } from "@bolteu/kalep-react";
import { resolveOptions } from "../../utils/resolveOptions";
import { useIsMounted } from "../../utils/useIsMounted";
export var SelectField = function SelectFieldComponent(_a) {
  var _b;
  var disabled = _a.disabled,
    onChange = _a.onChange,
    value = _a.value,
    multiple = _a.multiple,
    validatorResults = _a.validatorResults,
    options = _a.options,
    label = _a.label,
    isCompact = _a.compact,
    name = _a.name,
    helperText = _a.helperText,
    rest = __rest(_a, ["disabled", "onChange", "value", "multiple", "validatorResults", "options", "label", "compact", "name", "helperText"]);
  var validationError = validatorResults === null || validatorResults === void 0 ? void 0 : validatorResults[0];
  var componentIsMounted = useIsMounted();
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    menuItems = _React$useState2[0],
    setMenuItems = _React$useState2[1];
  // Initial data load
  React.useEffect(function () {
    resolveOptions(options).then(function (result) {
      if (!componentIsMounted.current) {
        return;
      }
      setMenuItems(result);
    });
  }, [componentIsMounted, options]);
  var fieldValue = React.useMemo(function getControlledValue() {
    if (value == null) {
      // it should not be undefined, that would imply uncontrolled component beneath, but form-react controls
      // the components it uses.
      // MultipleSelect can not accept null, it needs an array.
      return multiple ? [] : null;
    }
    function getOptionFromValue(item) {
      var _a;
      return (_a = menuItems.find(function findOption(menuItem) {
        return menuItem.value === item;
      })) !== null && _a !== void 0 ? _a : null;
    }
    if (multiple && Array.isArray(value)) {
      return value.map(getOptionFromValue).filter(function (item) {
        return item != null;
      });
    }
    return getOptionFromValue(value);
  }, [menuItems, multiple, value]);
  var handleChange = React.useCallback(function onChangeHandler(newValue) {
    var change;
    if (typeof change === "string" && change.trim().length === 0) {
      change = null;
    } else if (Array.isArray(newValue)) {
      change = newValue.map(function (item) {
        return item.value;
      });
    } else {
      change = newValue === null || newValue === void 0 ? void 0 : newValue.value;
    }
    onChange({
      value: change
    });
  }, [onChange]);
  var inputLabel = "".concat(label !== null && label !== void 0 ? label : String(name)).concat(Array.isArray(fieldValue) ? " (".concat(fieldValue.length, ")") : "");
  return /*#__PURE__*/React.createElement(Select, Object.assign({
    error: !!validationError,
    name: String(name),
    value: fieldValue,
    onChange: handleChange,
    options: menuItems,
    multiple: multiple,
    label: inputLabel,
    disabled: disabled || menuItems === undefined,
    fullWidth: true,
    loading: menuItems === undefined,
    size: isCompact ? "sm" : undefined,
    helperText: (_b = validationError === null || validationError === void 0 ? void 0 : validationError.error) !== null && _b !== void 0 ? _b : helperText
  }, rest));
};